import dayjs from 'dayjs';
import { mapLegalForm, reverseMapLegalForm } from 'utils/mapper';

/**
 * @description Converts raw API response data into a format compatible with Ant Design form fields.
 * Use this to populate form initial values after fetching data from the backend.
 * @param {object} apiData The API response object.
 * @returns {object} Form-compatible data object.
 */
export function mapApiDataToForm(apiData) {
  if (!apiData) return {};

  const formData = {
    companyName: apiData.companyName ?? null,
    establishmentDate: apiData.foundingDate
      ? dayjs(apiData.foundingDate)
      : null,
    taxIdentificationNumber: apiData.afm ?? null,
    companySize: apiData.size ?? 'MEDIUM',
    activityCode: apiData.kad ?? null,
    legalForm: mapLegalForm(apiData.legalForm),
    streetNumber: apiData.address ?? null,
    postalCode: apiData.postalCode ?? null,
    website: apiData.companyWebsite ?? null,
    taxOffice: apiData.doy ?? null,
    phoneHeadquarters: apiData.companyPhone ?? null,
    emailHeadquarters: apiData.companyEmail ?? null,
    firstName: apiData.firstName ?? null,
    lastName: apiData.lastName ?? null,
    occupation: apiData.profession ?? null,
    phoneContact: apiData.contactPhone ?? null,
    emailContact: apiData.contactEmail ?? null,
  };
  return formData;
}

/**
 * @description Transforms Ant Design form values into the structure expected by the API for submission.
 * Use this before sending form data in the request.
 * @param {object} formData The data object collected from the form fields.
 * @returns {object} API-compatible payload object.
 */
export function mapFormDataToApi(formData) {
  if (!formData) return {};

  // We won't pass the disabled info in the request
  const apiData = {
    // companyName: formData.companyName ?? null,
    // establishmentDate: formData.establishmentDate
    //   ? dayjs(formData.establishmentDate).format('YYYY-MM-DD')
    //   : null,
    // afm: formData.taxIdentificationNumber ?? null,
    size: formData.companySize ?? null,
    kad: formData.activityCode ?? null,
    legalForm: reverseMapLegalForm(formData.legalForm),
    address: formData.streetNumber ?? null,
    postalCode: formData.postalCode ?? null,
    companyWebsite: formData.website ?? null,
    doy: formData.taxOffice ?? null,
    companyPhone: formData.phoneHeadquarters ?? null,
    companyEmail: formData.emailHeadquarters ?? null,
    firstName: formData.firstName ?? null,
    lastName: formData.lastName ?? null,
    profession: formData.occupation ?? null,
    contactPhone: formData.phoneContact ?? null,
    contactEmail: formData.emailContact ?? null,
  };
  return apiData;
}
